export default "__VITE_ASSET__DLFzEbGX__"